export default (): string => '/api/utility/playlistOwnerTypes';
